import { render } from "./VisitAttachmentsHC.vue?vue&type=template&id=0969d044&ts=true"
import script from "./VisitAttachmentsHC.ts?vue&type=script&lang=ts&external"
export * from "./VisitAttachmentsHC.ts?vue&type=script&lang=ts&external"

import "./VisitAttachmentsHC.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__